/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const InshellService = {
  async PlaceOnHold(payload) {
    const url = `api/AlmondcoInshellLotAllocation/PlaceOnHold`;
    return await ApiService.post(url, payload);
  },

  async AcceptOffer(payload) {
    const url = `api/AlmondcoInshellLotAllocation/AcceptOffer`;
    return await ApiService.post(url, payload);
  },

  async RemoveReservation(payload) {
    const url = `api/AlmondcoInshellLotAllocation/RemoveReservation`;
    return await ApiService.post(url, payload);
  },

  async RemoveOffer(payload) {
    const url = `api/AlmondcoInshellLotAllocation/RemoveOffer`;
    return await ApiService.post(url, payload);
  },

  async RemoveHold(payload) {
    const url = `api/AlmondcoInshellLotAllocation/RemoveHold`;
    return await ApiService.post(url, payload);
  },

  async ReserveLot(payload) {
    const url = `api/AlmondcoInshellLotAllocation/ReserveLot`;
    return await ApiService.post(url, payload);
  },

  async OfferLot(payload) {
    const url = `api/AlmondcoInshellLotAllocation/OfferLot`;
    return await ApiService.post(url, payload);
  },

  async getHistory(lotNo) {
    const url = `api/AlmondcoInshellLotAllocation/${lotNo}/History`;
    return await ApiService.get(url);
  },

  async getAlmondcoCustomerAgentSubRegionByAgentCode(AgentCode) {
    const requestScreenData = {
      url: "api/AlmondcoCustomerAgentSubRegion",
      filter: `AgentCode eq '${AgentCode}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },


  async getAlmondcoCustomerAgentSubRegionByCode(SubRegionCode) {
    const requestScreenData = {
      url: "api/AlmondcoCustomerAgentSubRegion",
      filter: `SubRegionCode eq '${SubRegionCode}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },


  async getAgentSupplierByCode(AgentCode) {
    const requestScreenData = {
      url: "api/AgentSupplier",
      // top: "1",
      filter: `Code eq '${AgentCode}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { InshellService };
